"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
exports.Marks = function (props) {
    var vertical = props.vertical, marks = props.marks, included = props.included, upperBound = props.upperBound, lowerBound = props.lowerBound, max = props.max, min = props.min;
    var marksKeys = Object.keys(marks);
    var marksCount = marksKeys.length;
    var unit = 100 / (marksCount - 1);
    var markWidth = unit * 0.9;
    var range = max - min;
    var elements = marksKeys
        .map(parseFloat)
        .sort(function (a, b) { return a - b; })
        .map(function (point) {
        var _a;
        var isActive = (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound);
        var markClassName = classnames_1.classNames((_a = {},
            _a[vdl_prefix_1.vdlPrefix('slider__mark')] = true,
            _a[vdl_prefix_1.vdlPrefix('slider__mark--active')] = isActive,
            _a[vdl_prefix_1.vdlPrefix('slider__mark--min')] = point === min,
            _a[vdl_prefix_1.vdlPrefix('slider__mark--max')] = point === max,
            _a));
        var bottomStyle = {
            bottom: (point - min) / range * 100 + "%"
        };
        var leftStyle = {
            width: markWidth + "%",
            marginLeft: -markWidth / 2 + "%",
            left: (point - min) / range * 100 + "%"
        };
        var style = vertical ? bottomStyle : leftStyle;
        var markPoint = marks[point];
        var markPointIsObject = typeof markPoint === 'object' && !React.isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        var markStyle = markPointIsObject ? __assign(__assign({}, style), markPoint.style) : style;
        return (React.createElement("span", { className: markClassName, style: markStyle, key: point }, markLabel));
    });
    return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('slider__marks') }, elements));
};
exports.Marks.displayName = 'Marks';
